import React from "react";
import { useHistory, Link } from 'react-router-dom';
import Truncate from 'react-truncate'
import "./Resume.scss";

function Resume({ text, margin, idPost, category, title, handleSelectArticle, onLanding}) {
  const history = useHistory();
  //const regex = /\s/g;
  //pathname: `/articulos/${category.toLowerCase()}/${title && title.toLowerCase().replace(regex, '-')}`
  const url = `/articulos/${category}/${idPost}`;
  
  return (
    <div className="resume">
        {/* <span className="resume-text-link" onClick={ () => {
          handleSelectArticle();
          history.push(url);
        }}> Leer artículo…</span> */}
      <div className={`resume-text-${margin}`}>
        <p>
          <Truncate lines={onLanding? 4 : 2} ellipsis={<span>...<b>Leer artículo...</b></span>}>
            {text}
          </Truncate>
        </p>
      </div>
    </div>
  );
}

export default Resume;
